import React from 'react';
import { Avatar, Typography } from 'antd';
import cx from 'classnames';
import styles from './style.module.scss';
const {
  Text
} = Typography;
const ClientCard = props => {
  const {
    avatar,
    name,
    color,
    lastname
  } = props;
  return <table className={cx('avatar-name', styles.container)}>
      <tbody>
        <tr style={{
        cursor: 'pointer'
      }}>
          <td>
            <Avatar src={avatar} className="avatar" style={color ? {
            borderColor: color
          } : {}} />
          </td>
          <td>
            <div className={cx('name', styles.name)}>
              <Text>{name}</Text>
              <Text> {lastname}</Text>
            </div>
          </td>
        </tr>
      </tbody>
    </table>;
};
export default ClientCard;